import {ITaggedField, IElement, ITemplateFields, ICommonAttributes, IArtboardsAttributes, IArtboardAttributes, IGroupAttributes, ITextAttributes, IImageAttributes, IShapeCommonAttributes, IShapeCircleAttributes, IShapeEllipseAttributes, IShapeLineAttributes, IShapeRectangleAttributes, IShapeRhombusAttributes, IShapeStarAttributes, IShapeTriangleAttributes} from 'routes/private/Editor/types'
import {getTaggedElementsId, getTaggedVisibleElements, getTaggedVisibleElementsId} from './selectDescribe'
import {IElementType, ISelectDescribeData} from 'routes/private/Editor/types'
import {IMultiEditingConfig, IMultiEditingFields, IMultiEditingCategory} from 'state/dsconfig/types';
import { cloneDeep, template } from 'lodash';
import { getEndNumber } from 'utils/selectDescribe';
import { IMultiEditingPickerField } from '@routes/private/Editor/Editor/Pickers/MultiEditingPicker/types';
import {removeLineBreak} from 'utils/text' 
import { group } from 'console';
import { findElementById, getParentElementId } from './editor';

const uuid = require('react-uuid');

export const allHidden = (selectDescribeFieldId: string, data: IElement[], taggedFields?: ITaggedField[]): boolean => {
    if(!taggedFields) return false;
    const allElements = getTaggedVisibleElements([selectDescribeFieldId], taggedFields!, data);
    if (!allElements || allElements.length === 0) return false;
    for (let i=0;i<allElements.length;i++) {
        if (!allElements[i]?.attributes.hidden) return false;
    }
    return true;
}

export const getCommonValue = (attribute: string, elementType: IElementType, selectDescribeFieldId: string, data: IElement[], taggedFields?: ITaggedField[], sendId?: boolean): string => {
    if(!taggedFields) return "";
    const allElements = getTaggedVisibleElements([selectDescribeFieldId], taggedFields!, data);
    let elements: IElement[] = [];
    for(let i=0;i<allElements.length;i++) {
        if(allElements[i]!==undefined && allElements[i]?.type===elementType) elements.push(allElements[i]!);
    }
    let attributeValue = "";
    let didRemoveLineBreak = false;
    let isTextStyle = false;
    if(elements.length>0) {
        attributeValue = elements[0].attributes[attribute];
        if (elementType === "Text" && elements[0].attributes[attribute] === undefined && elements[0].attributes.style && elements[0].attributes.style[attribute] !== undefined) {
            isTextStyle = true;
            attributeValue = elements[0].attributes.style[attribute];
        }
        for(let i=0;i<elements.length;i++) {
            if (isTextStyle) {
                if(elements[i].attributes.style[attribute]!==attributeValue) {
                    attributeValue = "";
                    break;
                }
            }
            else {
                if(elements[i].attributes[attribute]!==attributeValue) {
                    if(removeLineBreak(elements[i].attributes[attribute])!==removeLineBreak(attributeValue)) {
                        attributeValue = "";
                        break;
                    }
                    else {
                        didRemoveLineBreak = true;
                    }
                }
            }
        }
        if (sendId) attributeValue = `${elements[0].id}/${attributeValue}`
    }
    if(didRemoveLineBreak) attributeValue = removeLineBreak(attributeValue);
    return attributeValue;
}

export const getCommonAttributes = (elementType: IElementType, selectDescribeFieldId: string, data: IElement[], taggedFields?: ITaggedField[]): ICommonAttributes | IArtboardsAttributes | IArtboardAttributes | IGroupAttributes |  ITextAttributes | IImageAttributes | IShapeCommonAttributes | IShapeCircleAttributes | IShapeEllipseAttributes | IShapeLineAttributes | IShapeRectangleAttributes | IShapeRhombusAttributes | IShapeStarAttributes | IShapeTriangleAttributes | any => {
    if(!taggedFields) return "";
    const allElements = getTaggedVisibleElements([selectDescribeFieldId], taggedFields!, data);
    let elements: IElement[] = [];
    for(let i=0;i<allElements.length;i++) {
        if(allElements[i]!==undefined && allElements[i]?.type===elementType) elements.push(allElements[i]!);
    }
    if(elements.length>0) {
        return elements[0].attributes;        
    }
    return undefined;
}

export const getDifferentValues = (attribute: string, elementType: IElementType, selectDescribeFieldId: string, data: IElement[], taggedFields?: ITaggedField[]): string[] => {
    if(!taggedFields) return [];
    const allElements = getTaggedVisibleElements([selectDescribeFieldId], taggedFields!, data);
    let elements: IElement[] = [];
    for(let i=0;i<allElements.length;i++) {
        if(allElements[i]!==undefined && allElements[i]?.type===elementType) elements.push(allElements[i]!);
    }
    let attributeValues : string[] = [];
    if(elements.length>0) {
        for(let i=0;i<elements.length;i++) {
            if (elements[i].attributes[attribute] !== undefined) {
                let value = removeLineBreak(elements[i].attributes[attribute]); 
                if (!attributeValues.includes(value)) {
                    attributeValues.push(value);
                }
            }
            else {
                if (elementType === "Text" && elements[i].attributes.style && elements[i].attributes.style[attribute] !== undefined) {
                    let value = elements[i].attributes.style[attribute]; 
                    attributeValues.push(value);
                }
            }
        }
    }
    return attributeValues;
}

export const getMultiEditingForTemplate = (generalMultiEditingConfig: IMultiEditingConfig, data: IElement[], selectDescribeTemplateData?: ISelectDescribeData): IMultiEditingConfig => {
    const orderedTemplateFields = orderTemplateFields(selectDescribeTemplateData?.templateFields);
    let multiEditingConfig = addTemplateFieldsForMultiEditing(generalMultiEditingConfig, orderedTemplateFields);
    multiEditingConfig = cleanEmptyMultiEditingCategoriesAndFields(multiEditingConfig, data, selectDescribeTemplateData?.taggedFields);
    return multiEditingConfig;
}

const compareTemplateFields = (item1: ITemplateFields, item2: ITemplateFields) => {
    if ( getEndNumber(item1.name)! < getEndNumber(item2.name)! ){
        return -1;
    }
    if ( getEndNumber(item1.name)! > getEndNumber(item2.name)! ){
        return 1;
    }
    return 0;
}

const orderTemplateFields = (templateFields?: ITemplateFields[]) => {
    let orderedTemplateFields = cloneDeep(templateFields);
    if(orderedTemplateFields) {
        orderedTemplateFields.sort(compareTemplateFields);
    }
    return orderedTemplateFields;
}

const addTemplateFieldsForMultiEditing = (multiEditingConfig: IMultiEditingConfig, templateFields?: ITemplateFields[]) => {
    let multiEditingConfigWithTemplateFields = cloneDeep(multiEditingConfig);
    if (templateFields) {
        for(let i=0;i<templateFields?.length;i++) {
            const endNumber = getEndNumber(templateFields[i].name);
            if(endNumber) {
                const field = findFieldConfigBySelectDescribeId(multiEditingConfigWithTemplateFields,templateFields[i].parentId);
                let newField = cloneDeep(field);
                if (newField) {
                    const generalCategory = findCategoryBySelectDescribeId(multiEditingConfigWithTemplateFields, templateFields[i].parentId);
                    if (generalCategory) {
                        const newCategory = findOrAddCategory(multiEditingConfigWithTemplateFields, generalCategory.name, endNumber, generalCategory.groupId); 
                        newField.id = uuid();
                        newField.selectDescribeField = templateFields[i].id;
                        const indexField = findIndexInsideCategory(generalCategory, newCategory, field!.id);
                        newCategory.fields.splice(indexField,0,newField);
                    }
                }
            }
        }
    }
    return multiEditingConfigWithTemplateFields;
}

const findIndexInsideCategory =  (generalCategory: IMultiEditingCategory, newCategory: IMultiEditingCategory, fieldId: string): number => {
    if (newCategory.fields.length===0) return 0;
    let index = 0;
    for(let i=0;i<generalCategory.fields.length;i++) {
        if (generalCategory.fields[i].id===fieldId) {
            return index;
        }
        if (generalCategory.fields[i].id===newCategory.fields[index].id) {
            index++;
        }
    } 
    return 0;
}

const findOrAddCategory = (multiEditingConfig: IMultiEditingConfig, categoryName: string, endNumber: number, groupId?: string): IMultiEditingCategory => {
    let lastPosition = multiEditingConfig.categories.length;
    for(let i=0;i<multiEditingConfig.categories.length;i++) {
        if(multiEditingConfig.categories[i].name.startsWith(categoryName)) {
            lastPosition = i;
        }
        if(multiEditingConfig.categories[i].name===categoryName + " " + endNumber) {
            return multiEditingConfig.categories[i];
        }
    }
    let newGroupId: string|undefined = undefined;
    if (groupId) {
        newGroupId = uuid();
        let newGroupName = "";
        for (let i=0;i<multiEditingConfig.groups.length;i++) {
            if (multiEditingConfig.groups[i].id === groupId) {
                newGroupName = multiEditingConfig.groups[i].name + " " + endNumber;
                break;
            }
        }
        let foundGroup = false;
        for (let i=0;i<multiEditingConfig.groups.length;i++) {
            if (multiEditingConfig.groups[i].name === newGroupName) {
                newGroupId = multiEditingConfig.groups[i].id;
                foundGroup = true;
                break;
            }
        }
        if(!foundGroup) {
            multiEditingConfig.groups.push({id: newGroupId!, name: newGroupName});
        }
    }
    multiEditingConfig.categories.splice(lastPosition+1,0,{id: uuid(), name: categoryName + " " + endNumber, groupId: newGroupId, fields: []});
    return multiEditingConfig.categories[lastPosition+1];
}

const findCategoryBySelectDescribeId = (multiEditingConfig: IMultiEditingConfig, selectDescribeId: string): IMultiEditingCategory|undefined => {
    for(let i=0;i<multiEditingConfig.categories.length;i++) {
        for(let a=0;a<multiEditingConfig.categories[i].fields.length;a++) {
            if(multiEditingConfig.categories[i].fields[a].selectDescribeField===selectDescribeId) {
                return multiEditingConfig.categories[i];
            }
        }
    }
    return undefined;
}

const findFieldConfigBySelectDescribeId = (multiEditingConfig: IMultiEditingConfig, selectDescribeId: string): IMultiEditingFields|undefined => {
    for(let i=0;i<multiEditingConfig.categories.length;i++) {
        for(let a=0;a<multiEditingConfig.categories[i].fields.length;a++) {
            if(multiEditingConfig.categories[i].fields[a].selectDescribeField===selectDescribeId) {
                return multiEditingConfig.categories[i].fields[a];
            }
        }
    }
    return undefined;
}

const hasFields = (groupId: string, multiEditingConfig: IMultiEditingConfig, data: IElement[], taggedFields?: ITaggedField[]): boolean => {
    for(let i=0;i<multiEditingConfig.categories.length;i++){
        let category = cloneDeep(multiEditingConfig.categories[i]);
        const fields = category.fields.map((field)=> { if(isFieldTagged(field.selectDescribeField,taggedFields)) return field });
        category.fields = [];
        for(let a=0;a<fields.length;a++) {
            if (fields[a]) {
                if (category.groupId && category.groupId === groupId) {
                    return true;
                }
            }
        }
    }
    return false;
}

const cleanEmptyMultiEditingCategoriesAndFields  = (multiEditingConfig: IMultiEditingConfig, data: IElement[], taggedFields?: ITaggedField[]) => {
    let cleanMultiEditingConfig: IMultiEditingConfig = {groups: multiEditingConfig.groups,categories: []};
    for(let i=0;i<multiEditingConfig.categories.length;i++){
        let category = cloneDeep(multiEditingConfig.categories[i]);
        const fields = category.fields.map((field)=> { if(isFieldTagged(field.selectDescribeField,taggedFields)) return field });
        category.fields = [];
        for(let a=0;a<fields.length;a++) {
            if (fields[a]) {
                let addFields = false;
                if (selectDescribeFieldHasVisibleElements(fields[a]!.selectDescribeField, data, taggedFields)) {
                    addFields = true;
                }
                else if (category.groupId && hasFields(category.groupId, multiEditingConfig, data, taggedFields)) {
                    addFields = true;
                }
                if (addFields) category.fields.push(fields[a]!);
            }
        }
        if (category.fields && category.fields.length>0) cleanMultiEditingConfig.categories.push(category);
    }
    return cleanMultiEditingConfig;
}

const selectDescribeFieldHasVisibleElements = (selectDescribeFieldId: string, data: IElement[], taggedFields?: ITaggedField[]): boolean => {
    const elementsIds = getTaggedVisibleElementsId([selectDescribeFieldId], taggedFields!, data);
    if (!elementsIds || elementsIds.length===0) return false;
    else return true;
}

const isFieldTagged = (fieldId: string, taggedFields?: ITaggedField[]):boolean => {
    if(taggedFields && taggedFields.length>0) {
        for(let i=0;i<taggedFields.length;i++) {
            if(taggedFields[i].id===fieldId && taggedFields[i].taggedElements && taggedFields[i].taggedElements.length>0) {
                return true;
            }            
        }
    }
    return false;
}

export const getMultiEditingFieldsForPicker = (categoryId: string, multiEditingConfig: IMultiEditingConfig, data: IElement[], taggedFields?: ITaggedField[]): IMultiEditingPickerField[] => {
    let categoryFields: IMultiEditingPickerField[] = [];  
    for(let i=0;i<multiEditingConfig.categories.length;i++){
        if(multiEditingConfig.categories[i].id===categoryId) {
            categoryFields = multiEditingConfig.categories[i].fields.map((field) => { return {id: field.id, elementType: field.elementType, selectDescribeFieldId: field.selectDescribeField, categoryId: categoryId, name: field.name}});
            break;
        }
    }
    let filteredFields = filterFieldsWithVisibleElements(categoryFields, data, taggedFields);
    return filteredFields;
}

export const filterFieldsWithVisibleElements = (fields: IMultiEditingPickerField[],data: IElement[], taggedFields?: ITaggedField[]): IMultiEditingPickerField[] => {
    let filteredFields: IMultiEditingPickerField[] = [];  
    for(let i=0;i<fields.length;i++){
        if(selectDescribeFieldHasVisibleElements(fields[i].selectDescribeFieldId, data, taggedFields)) {
            filteredFields.push({...fields[i]})
        }
    }
    return filteredFields;
}

export const findSelectedCategoryInGroup = (groupId: string, multiEditingConfig: IMultiEditingConfig, data: IElement[], taggedFields?: ITaggedField[]):string => {
    let selectedCategory = "";
    let maxVisibleFields = 0;
    for(let i=0;i<multiEditingConfig.categories.length;i++){
        if (multiEditingConfig.categories[i].groupId && multiEditingConfig.categories[i].groupId === groupId) {
            let categoryVisibleFields = 0;
            const fields = multiEditingConfig.categories[i].fields.map((field)=> { if(isFieldTagged(field.selectDescribeField,taggedFields)) return field });
            for(let a=0;a<fields.length;a++) {
                if (fields[a]) {
                    if (selectDescribeFieldHasVisibleElements(fields[a]!.selectDescribeField, data, taggedFields)) {
                        categoryVisibleFields ++;
                    }
                }
            }
            if (categoryVisibleFields > maxVisibleFields) {
                maxVisibleFields = categoryVisibleFields;
                selectedCategory = multiEditingConfig.categories[i].id;
            }
        }
    }
    return selectedCategory;
}

export const findIElementGroupByMultiEditingCategory = (multiEditingCategoryId: string, multiEditingConfig: IMultiEditingConfig, data: IElement[], taggedFields: ITaggedField[]):string[] => {
    let iElementGroupsId: string[] = [];
    let maxChilds = 0;
    for(let i=0;i<multiEditingConfig.categories.length;i++){
        if (multiEditingConfig.categories[i].groupId && multiEditingConfig.categories[i].id === multiEditingCategoryId) {
            const multiEditingFields = multiEditingConfig.categories[i].fields.map((field)=> { if(isFieldTagged(field.selectDescribeField,taggedFields)) return field });
            if (multiEditingFields && multiEditingFields.length>0) {
                const elementsIds = getTaggedElementsId(multiEditingFields!.map((multiEditingField) => {return multiEditingField!.selectDescribeField}),taggedFields);
                for (let a=0;a<elementsIds.length;a++) {
                    const parentId = getParentElementId(elementsIds[a], data);
                    if (parentId)
                    {
                        const parentNode = findElementById(data,parentId)
                        if (parentNode?.type == 'Artboard')
                            iElementGroupsId.push(elementsIds[a]);
                        else
                        {
                            if (parentId && !iElementGroupsId.includes(parentId)){
                                iElementGroupsId.push(parentId);
                            }
                        }
                    }
                }
            }
        }
    }
    return iElementGroupsId;
}